module.exports = __webpack_public_path__ + "img/about_2_1.8458c761.jpg";